import React, { useState } from 'react';
import { Row, Col, FormGroup, Label, Card, CardBody, Input } from 'reactstrap';
import ClearIcon from '@mui/icons-material/Clear';

export function FiltroRevendas(props) {
	const {
		user,
		filtroStatus,
		setFiltroStatus,
		setFiltroPesquisa,
		setPagina
	} = props;
	const [inputValue, setInputValue] = useState('')
	const [timer, setTimer] = useState(null)

	const handleChange = event => {
		setFiltroStatus(event.target.value);
		setPagina(1)
	};

	const inputChanged = e => {
		setPagina(1)
		setInputValue(e.target.value)
		clearTimeout(timer)

		const newTimer = setTimeout(() => {
			setFiltroPesquisa(e.target.value)
		}, 1000)

		setTimer(newTimer)
	}

	function handlerLimparFiltro() {
		setFiltroStatus('');
		setInputValue('');
		setFiltroPesquisa('');

		setPagina(1);
	}

	return (
		<Card
			style={{
				boxShadow: 'unset',
				borderRadius: '0px 18px 18px 18px',
			}}>
			<CardBody>
				<Row style={{ justifyContent: 'center' }} xs="12" md="12" lg="12">
					<Col xs="12" md="12" lg={user.dados.permissoes.view_credito_revenda ? 9 : 12}>
						<FormGroup>
							<Label style={{ fontWeight: 'bold' }}>Buscar Revendedor</Label>
							<Input
								type="text"
								placeholder="Qual o Revendedor?"
								value={inputValue}
								onChange={inputChanged}
							/>
						</FormGroup>
					</Col>
					{user.dados.permissoes.view_credito_revenda ?
						<Col xs="12" md="12" lg="3">
							<FormGroup>
								<Label style={{ fontWeight: 'bold' }}>Organizar por:</Label>
								<Input
									type="select"
									value={filtroStatus}
									onChange={handleChange}
								>
									{user.dados.cargo.toLowerCase() === '' ?
										<>
											<option value="">
												Sem filtro
											</option>
											<option value="APROVADO">
												Autorizado
											</option>
											<option value="REPROVADO">
												Não Autorizado
											</option>
											<option value="PENDENTE">
												Pendente
											</option>

										</>
										:
										<>
											<option value="">
												Sem filtro
											</option>
											<option value="maior">
												Maior crédito
											</option>
											<option value="menor">
												Menor crédito
											</option>

										</>}
								</Input>
							</FormGroup>
						</Col> : <></>}
					<Col>
						<button
							style={{ all: 'unset', cursor: 'pointer', color: '#333333', float: 'right' }}
							type='button'
							onClick={() => handlerLimparFiltro()}>
							<ClearIcon style={{ color: '#0AD6EA' }} />
							{' '}
							Limpar Filtros
						</button>
					</Col>
				</Row>
			</CardBody>
		</Card>
	);
}
